import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const About = () => {
  return (
    <div className="bg-[#FAF8F5]">
      {/* Hero Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="font-heading text-4xl md:text-5xl font-semibold text-[#6B5845] mb-4">
              À propos
            </h1>
            <p className="font-heading text-xl text-[#8B7355]">
              L'histoire de Djennah, photographe maternité à Haguenau
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/klrg9o8z_4N9A0062.JPG" 
                alt="Djennah - Photographe maternité Haguenau" 
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="space-y-6">
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Je suis photographe spécialisée en maternité et naissance depuis 9 ans. Mon appareil à la main, je capture les instants précieux de la vie : un ventre qui s'arrondit, les premiers regards d'un bébé, les émotions d'une nouvelle famille. C'est bien plus qu'un métier : c'est une passion profonde, née avec ma propre expérience de la maternité.
              </p>
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Devenir maman a été un véritable tournant dans ma vie, une révélation qui m'a guidée naturellement vers cet univers si intime, si rempli d'amour. Depuis, j'ai à cœur d'accompagner chaque famille avec douceur et bienveillance, dans le respect de leur rythme et de leur histoire.
              </p>
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Je suis reconnue pour ma patience, ma tendresse et ma capacité à mettre à l'aise les tout-petits comme les parents. Chaque séance est un moment suspendu, où je prends le temps de créer un cocon rassurant, propice à des images naturelles et pleines d'authenticité.
              </p>
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Ce qui me touche le plus ? Savoir que les souvenirs que je crée seront chéris toute une vie. Ces images traverseront le temps, témoins des débuts d'une grande aventure familiale.
              </p>
              <p className="font-heading text-xl text-[#8B7355] mt-6">
                Bienvenue dans mon univers, où la lumière, l'amour et la simplicité racontent vos plus belles histoires.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Studio Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
                Un studio pensé pour votre confort
              </h2>
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Offrez à votre bébé ses tout premiers souvenirs dans un studio cosy et chaleureux, pensé pour votre confort (table à langer, chauffe-biberon…) et pour capturer avec douceur la magie de ses premiers instants en famille.
              </p>
              <p className="font-body text-base text-[#6B5845] leading-relaxed">
                Réservez dès maintenant ce moment unique.
              </p>
              <Link to="/contact">
                <Button className="bg-[#8B7355] hover:bg-[#6B5845] text-white font-body px-8 py-6 text-base rounded-lg btn-primary">
                  Contactez-moi
                </Button>
              </Link>
            </div>
            <div className="rounded-lg shadow-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_woolurban/artifacts/3begdmvk_photo%2069.jpeg" 
                alt="Séance photo grossesse avec enfant - Studio Haguenau" 
                className="w-full h-[400px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-[#6B5845] mb-4">
              Photographe Grossesse, Naissance & Famille
            </h2>
            <p className="font-heading text-xl text-[#8B7355] mb-2">
              Des souvenirs pour la vie
            </p>
          </div>

          <div className="space-y-6 max-w-4xl mx-auto">
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Parce que chaque instant autour de la maternité est unique, je vous propose des séances photo sur-mesure pour immortaliser ces précieux moments : la grossesse, la naissance de votre bébé, et vos premiers instants en famille.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Photographe spécialisée en maternité et nouveau-né depuis plus de neuf ans, je mets tout mon savoir-faire et ma sensibilité au service de vos souvenirs. Mon studio photo, cosy et chaleureux, est entièrement équipé pour accueillir les tout-petits et leurs parents : table à langer, chauffe-biberon, espace cocooning… tout est pensé pour votre confort et celui de bébé.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Chaque séance photo est une parenthèse de douceur, où je prends le temps de créer des images naturelles, pleines d'émotion et d'authenticité. Que ce soit pour une séance grossesse en lumière naturelle, une séance nouveau-né dans les premiers jours de vie, ou un shooting en famille rempli de tendres instants, je vous accompagne avec bienveillance, douceur et patience.
            </p>
            <p className="font-body text-base text-[#6B5845] leading-relaxed">
              Les images que je vous remets sont bien plus que de simples photos : ce sont des souvenirs précieux que vous garderez toute votre vie, et que vos enfants aimeront redécouvrir en grandissant.
            </p>
          </div>

          <div className="text-center mt-12">
            <p className="font-body text-base text-[#8B7355] mb-6">
              Réservez dès maintenant votre séance photo grossesse, naissance ou famille, et offrez-vous un moment unique pour célébrer l'amour, la vie et les liens qui vous unissent.
            </p>
            <Link to="/contact">
              <Button className="bg-[#8B7355] hover:bg-[#6B5845] text-white font-body px-8 py-6 text-base rounded-lg btn-primary">
                Réserver une séance
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Instagram CTA Section */}
      <section className="py-20 bg-[#F5EDE4]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6">
          <h2 className="font-heading text-3xl font-semibold text-[#6B5845]">
            Suivez nos créations sur Instagram
          </h2>
          <p className="font-body text-base text-[#6B5845] leading-relaxed">
            Découvrez nos dernières séances photo maternité et naissance, nos coulisses et bien plus encore !
          </p>
          <a 
            href="https://www.instagram.com/yastudio_photography/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button className="bg-gradient-to-r from-[#E1306C] to-[#FD1D1D] hover:opacity-90 text-white font-body px-8 py-6 text-base rounded-lg btn-primary inline-flex items-center space-x-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <span>Suivez-nous sur Instagram</span>
            </Button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;